import { render, staticRenderFns } from "./m-address-balance-graph.vue?vue&type=template&id=33b64432&scoped=true&"
import script from "./m-address-balance-graph.vue?vue&type=script&lang=ts&"
export * from "./m-address-balance-graph.vue?vue&type=script&lang=ts&"
import style0 from "./m-address-balance-graph.vue?vue&type=style&index=0&id=33b64432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b64432",
  null
  
)

export default component.exports